import AfterPayLandingPage from './AfterPayLandingPage'

export default AfterPayLandingPage
